import { Stack, SizableText, YStack, color } from '@mythical/ui'

import { PatternBackground } from 'app/components/primitive/PatternBackground'
import { ContentLockButton } from '../content/ContentLockButton'
import { useStores } from 'app/store'
import Section from '../structure/Section'
import { IconLock } from '../primitive/Icon'

type CommentLockProps = {
  commentCount: number
}

const CommentLock = ({ commentCount = 0 }: CommentLockProps) => {
  const { userStore } = useStores()
  const isLoggedIn = !!userStore?.user?.id
  const canMemberfulLink = userStore?.canMemberfulLink ?? false

  return (
    <Section
      title="Comments"
      titleHighlight={
        <>
          {commentCount} <IconLock size={18} y={1.5} color="$fgSecondary" />
        </>
      }
    >
      <Stack w="100%" position="relative" br="$2" bg="$bgTertiary" ov="hidden">
        <PatternBackground color={color.bgPrimary} opacity={1} tileSize={148} />

        <YStack
          ai="center"
          jc="center"
          mx="auto"
          gap="$3.5"
          px="$3.5"
          py="$10.5"
        >
          <SizableText
            ta="center"
            fontFamily="$display"
            size="$l"
            tt="uppercase"
            maw={465}
          >
            {isLoggedIn
              ? 'Go All Access to Join the Discussion'
              : 'Comments Are for Members Only'}
          </SizableText>

          <SizableText ta="center" size="$m" fow="500" maw={280}>
            {isLoggedIn
              ? 'Upgrade your membership to unlock the full community experience.'
              : 'Sign up to add your voice to the Mythical community.'}
          </SizableText>

          {!(isLoggedIn && !canMemberfulLink) && (
            <ContentLockButton
              loggedOutLabel={canMemberfulLink ? 'Become a member' : 'Log in'}
              upgradeLabel="Join All Access"
            />
          )}
        </YStack>
      </Stack>
    </Section>
  )
}

export default CommentLock
